export default {
    ipKontaktPersonerApp: () => import('./kontakt-personer'),
    ipAdresseVirksomhedApp: () => import('./adresse-virksomhed'),
    ipLaerlingeordningApp: () => import('./laerlingeordning'),
    ipIndberetningerApp: () => import('./indberetninger'),
    ipIndberetningerDetailsApp: () => import('./indberetninger-details'),
    ipBetalingshistorikApp: () => import('./betalingshistorik'),
    ipIndberetningerKladdeApp: () => import('./indberetninger-kladde'),
    ipPensionsPlanApp: () => import('./pensionsplan'),
    ipBegunstigelsesflowApp: () => import('./begunstigelsesflow-app'),
    ipSundhedsordningForFunktionaererApp: () => import('./sundhedsordning-for-funktionaerer')
};
